import { href, redirect } from "react-router";

import { Storage } from "~/utils/storage";
import { CURRENT_USER_TOKEN } from "~/utils/storage-keys";

import { UserTokenSchema } from "./api-schemas";

export async function requireUser() {
  const currentUserToken = getUserToken();
  if (!currentUserToken?.access) throw redirect(href("/login"));
  return currentUserToken;
}

export async function forbidUser() {
  const currentUserToken = getUserToken();
  if (currentUserToken?.access) throw redirect(href("/"));

  return currentUserToken;
}

export function getUserToken() {
  const userToken = Storage.local.get(CURRENT_USER_TOKEN);
  if (!userToken) return null;

  try {
    return UserTokenSchema.parse(userToken);
  } catch {
    Storage.local.remove(CURRENT_USER_TOKEN);
    return null;
  }
}

export function setUserToken(token: any, merge = false) {
  const data = merge ? { ...getUserToken(), ...token } : token;
  Storage.local.set(CURRENT_USER_TOKEN, data);
}

export function forgetUserToken() {
  Storage.local.remove(CURRENT_USER_TOKEN);
}
